'use client'

import { GridSection } from '@/components/marketing/fragments/grid-section'
import { AnimatedGridPattern } from '@/components/ui/animated-grid-pattern'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import * as React from 'react'
import { SiteHeading } from '../fragments/site-heading'

export function TermsOfUse(): React.JSX.Element {
  const { i18n } = useLingui()

  return (
    <div className='relative'>
      <AnimatedGridPattern />
      <GridSection>
        <div className='bg-diagonal-lines'>
          <div className='flex flex-col bg-background md:px-12 px-4 py-20 md:py-24 lg:mx-12 lg:border-x overflow-hidden'>
            <SiteHeading badge={msg`Legal`} title={msg`Terms of Use`} />
            <div className='prose max-w-5xl text-justify mx-auto text-muted-foreground text-sm sm:text-sm md:text-base'>
              <p>
                {i18n._(
                  'Welcome to Pione Joint Stock Company. These Terms of Use govern your access to and use of our websites, platforms, applications, and services, including but not limited to PIONE Wallet, PIONE Farm, PIONE House, PIONE Mart, PIONE Swap, PIONE Care, PIONE Chain, PIONE NFT, and other blockchain- or AI-integrated products and services provided by Pione Group. By accessing or using our Services, you agree to be bound by these Terms. If you do not agree to any part of the Terms, please do not use our Services.'
                )}
              </p>

              <h2 className='text-xl font-bold mt-8 mb-4'>
                {i18n._('1. Introduction to Pione Group')}
              </h2>
              {/* <p>
                {i18n._(
                  'Pione Group is a leading technology company in Vietnam, specializing in comprehensive blockchain solutions, artificial intelligence (AI), and Web3 technologies. Our headquarters is located at 304/18 Tan Ky Tan Quy Street, Tan Son Nhi Ward, Tan Phu District, Ho Chi Minh City. We aim to shape the digital future by building transparent, secure, and user-friendly digital ecosystems that create practical and sustainable value for society.'
                )}
              </p> */}

              <h2 className='text-xl font-bold mt-8 mb-4'>{i18n._('2. Conditions of Use')}</h2>
              <ul className='list-disc pl-6'>
                <li>
                  {i18n._(
                    'Eligibility: Our Services are intended for users aged 18 and older or with parental/guardian consent if under 18. You must comply with local laws and regulations when using the Services.'
                  )}
                </li>
                <li>
                  {i18n._(
                    'User Account: Some Services may require you to create an account. You are responsible for maintaining the confidentiality of your account information, including your password, and must notify us immediately if you detect any unauthorized use.'
                  )}
                </li>
                <li>
                  {i18n._(
                    'Prohibited Conduct: You may not use the Services to engage in illegal, fraudulent, or harmful activities; interfere with the operation of the Services, including cyberattacks or exploiting security vulnerabilities; or distribute harmful, offensive, or infringing content.'
                  )}
                </li>
              </ul>

              <h2 className='text-xl font-bold mt-8 mb-4'>
                {i18n._('3. Rights and Responsibilities of Pione Group')}
              </h2>
              <ul className='list-disc pl-6'>
                <li>
                  {i18n._(
                    'Service Provision: We are committed to providing high-quality Services but do not guarantee uninterrupted or error-free service.'
                  )}
                </li>
                <li>
                  {i18n._(
                    'Data Security: We use modern blockchain and encryption technologies to protect your data. However, you are responsible for securing your own device and personal information.'
                  )}
                </li>
                <li>
                  {i18n._(
                    'Service Modifications: We reserve the right to modify, suspend, or discontinue any part of the Services without prior notice.'
                  )}
                </li>
              </ul>

              <h2 className='text-xl font-bold mt-8 mb-4'>{i18n._('4. Intellectual Property')}</h2>
              <p>
                {i18n._(
                  'All content, trademarks, logos, source code, and other materials related to the Services are owned by Pione Group or its licensed partners. You may not copy, distribute, or use such content without our written permission.'
                )}
              </p>

              <h2 className='text-xl font-bold mt-8 mb-4'>
                {i18n._('5. Blockchain and Digital Assets')}
              </h2>
              <ul className='list-disc pl-6'>
                <li>
                  {i18n._(
                    'Risks: Blockchain-related Services may carry risks, including loss of digital assets due to user error, cyberattacks, or market volatility. You assume full responsibility when using these Services.'
                  )}
                </li>
                <li>
                  {i18n._(
                    'Private Key: You must manage your private key yourself. Pione Group does not store or have access to your private key and cannot recover digital assets if you lose it.'
                  )}
                </li>
              </ul>

              <h2 className='text-xl font-bold mt-8 mb-4'>
                {i18n._('6. Limitation of Liability')}
              </h2>
              <p>
                {i18n._(
                  'To the extent permitted by law, Pione Group shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of the Services, including but not limited to loss of data or digital assets, service interruptions, or actions by third parties or other users.'
                )}
              </p>

              <h2 className='text-xl font-bold mt-8 mb-4'>{i18n._('7. Termination of Use')}</h2>
              <p>
                {i18n._(
                  'We reserve the right to suspend or terminate your access to the Services if you violate these Terms or if we suspect you are engaged in illegal or harmful activities.'
                )}
              </p>

              <h2 className='text-xl font-bold mt-8 mb-4'>{i18n._('8. Changes to the Terms')}</h2>
              <p>
                {i18n._(
                  'We may update these Terms at any time. Changes will take effect immediately upon being posted on the website or notified through the Services. Your continued use of the Services after changes indicates your acceptance of the new Terms.'
                )}
              </p>

              <h2 className='text-xl font-bold mt-8 mb-4'>
                {i18n._('9. Governing Law and Dispute Resolution')}
              </h2>
              <p>
                {i18n._(
                  'These Terms are governed by the laws of Vietnam. Any disputes arising will be resolved at the competent People’s Court in Ho Chi Minh City.'
                )}
              </p>
            </div>
          </div>
        </div>
      </GridSection>
    </div>
  )
}
